import React from 'react';

import { uiRoutes } from '@consumer-frontend/api';
import { Icon, Link } from '@consumer-frontend/shared-ui';

import { CnuOsano } from './Osano';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/footer.scss';

const primaryLinks: { route: string; text: string; }[] = [
  {
    route: uiRoutes.products,
    text: 'Products',
  },
  {
    route: uiRoutes.ratesAndTerms,
    text: 'Rates and Terms',
  },
  {
    route: uiRoutes.contactUs,
    text: 'Contact Us',
  },
  {
    route: uiRoutes.faq,
    text: 'FAQ',
  },
  {
    route: uiRoutes.aboutUs,
    text: 'About Us',
  },
  {
    route: uiRoutes.blog,
    text: 'Blog',
  },
  {
    route: uiRoutes.privacyPolicy,
    text: 'Privacy Policy',
  },
  {
    route: uiRoutes.californiaPrivacyPolicy,
    text: 'California Privacy Policy',
  },
  {
    route: uiRoutes.termsOfUse,
    text: 'Terms of Use',
  },
  {
    route: uiRoutes.serviceOfProcess,
    text: 'Service of Process',
  },
  {
    route: uiRoutes.optOut,
    text: 'Opt Out',
  },
];

const seoLinks: { route: string; text: string; }[] = [
  {
    route: uiRoutes.paydayLoanAlternatives,
    text: 'Payday Loan Alternatives',
  },
  {
    route: uiRoutes.cashAdvance,
    text: 'Cash Advance',
  },
  {
    route: uiRoutes.onlineLoans,
    text: 'Online Loans',
  },
  {
    route: uiRoutes.installmentLoans,
    text: 'Installment Loans',
  },
  {
    route: uiRoutes.lineOfCredit,
    text: 'Line of Credit',
  },
  {
    route: uiRoutes.fastCash,
    text: 'Fast Cash',
  },
  {
    route: uiRoutes.onlineSecurity,
    text: 'Online Security',
  },
];

export type LinksT = React.FC;

export const Links: LinksT = () => {
  return (
    <div className="links">
      <ul className="link-group">
        <li><Link to={import.meta.env.VITE_CNUFE_HOME}>Home<Icon iconName="chevron-right" /></Link></li>
        {primaryLinks.map(({
          route,
          text,
        }) => (
          <li><Link to={route}>{text} <Icon iconName="chevron-right" /></Link></li>
        ))}
      </ul>
      <ul className="link-group">
        {seoLinks.map(({
          route,
          text,
        }) => (
          <li><Link to={route}>{text} <Icon iconName="chevron-right" /></Link></li>
        ))}
        <li><CnuOsano /></li>
      </ul>
    </div>
  );
};
